export default "__VITE_ASSET__BuF$itAq__"